import useTranslations from '@/i18n/useTranslations';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/ConfirmUsernameChange.css';

export default function ConfirmUsernameChange({ open, close, onConfirm, newUsername, userType }) {
  const t = useTranslations('common.user_settings.edit_profile');

  return (
    <>
      <GenericPopup
        open={open}
        className="generic-popup_content remove-scrollbar edit-profile__confirm-username-popup"
        opacity
      >
        <div className="generic-popup__header">
          <Text className="generic-popup__header-text-theme">
            {t('confirm_username.title')}
          </Text>
          <XIcon className="generic-popup__close" onClick={close} />
        </div>
        <Text className="edit-profile__confirm-username-text" paragraph justify>
          {t('confirm_username.message_prefix')} <span>{newUsername}</span> {t('confirm_username.message_suffix')}{' '}

          {
            userType === "gallery" ? 
              t('confirm_username.gallery_notice')
              :
              t('confirm_username.default_notice')
          }
        </Text>

        <ContinueButton className="edit-profile__confirm-username-button font-size-medium" onClick={()=>{close(); onConfirm();}}>
          {t('confirm_username.confirm_button')}
        </ContinueButton>
      </GenericPopup>
    </>
  );
}
